// extracted by mini-css-extract-plugin
export default {"passConfiguration":"pass-configuration_passConfiguration__FYrCD"};